import React, { useCallback, useContext, useEffect, useState } from "react";
import Dashboard from "../Dashboard";
import { Box, Chip, Paper, Tab, Tabs } from "@material-ui/core";
import AddIcon from "@mui/icons-material/Add";
import a11yProps from "../../../../constants/tabPanelProps/ayProps";
import { CATEGORY_LIST } from "../../../../constants/categoryList/CategoryList";
import Topbar from "../../../shared/topbar/Topbar";
import { useNavigate } from "react-router-dom";
import { GROUP_LIST } from "../../../../constants/groupList/GroupList";
import useQuery from "../../../../hooks/useQuery";
import GroupContext from "../../../../contexts/groupContext/groupContext";
import { Button } from "@mui/material";

const GroupDashboard = () => {
	const [tabLabel, setTabLabel] = useState(0);
	const navigate = useNavigate();
	const { group_number, setGroup } = useContext(GroupContext);
	// const handleClickToAddRecord = useCallback(() => {
	// 	const pathname = "/idr/add-record";
	// 	navigate(pathname);
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, []);
	const handleLabelChange = useCallback(
		(event: any, value: number) => {
			if (value === 0) {
				setGroup(220);
			}
			if (value === 1) {
				setGroup(188);
			}
			if (value === 2) {
				setGroup(225);
			}
			if (value === 3) {
				setGroup(300);
			}
		},
		[setGroup]
	);

	useEffect(() => {
		if (group_number === 220) {
			setTabLabel(0);
		}
		if (group_number === 188) {
			setTabLabel(1);
		}
		if (group_number === 225) {
			setTabLabel(2);
		}
		if (group_number === 300) {
			setTabLabel(3);
		}
	}, [group_number]);

	return (
		<div className="landing">
			<Topbar />
			<div style={{ textAlign: "start", marginBottom: "2rem" }}>
				{/* <Button
					// onClick={handleClickToAddRecord}
					// onDelete={() => null}
					// deleteIcon={<AddIcon />}
					// label="Generate Report"
					className="button-container"
					variant="contained"
					color="primary"
				>
					Generate Report
				</Button>
				{/* <hr></hr> */}
				{/* <div
					style={{
						borderBottom: "solid",
						borderBottomWidth: "1px",
						marginTop: "20px",
						marginRight: "2rem",
						color: "#AB455C"
					}}
				></div>  */}
			</div>
			{/* <Paper elevation={3} style={{ borderRadius: "15px", padding: "2rem", paddingTop: "10px" }}> */}
			<div style={{ borderRadius: "15px", paddingBottom: "2rem", paddingRight: "2rem", marginTop: "2rem" }}>
				<Box sx={{ borderBottom: "none", borderRadius: "15px" }}>
					<Tabs
						value={tabLabel}
						onChange={handleLabelChange}
						TabIndicatorProps={{
							style: {
								border: "none",
								background: "blueViolet"
							}
						}}
						variant="scrollable"
						scrollButtons="auto"
						aria-label="scrollable auto tabs example"
						className="glb-tab-panel-green"
					>
						{GROUP_LIST.map((group, index) => {
							return (
								<Tab
									label={group.name}
									key={index}
									className="glb-tab-label"
									{...a11yProps(index)}
									style={{ fontWeight: "bold", fontSize: "1rem", textTransform: "capitalize" }}
								/>
							);
						})}
					</Tabs>
					{/* <h2>button</h2> */}
				</Box>
				<Dashboard group_index={tabLabel} />
			</div>
			{/* </Paper> */}
		</div>
	);
};

export default GroupDashboard;
